import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Cookie from 'js-cookie';

// functions
import { decimalOrBust } from '../../utilities/currency';
import { resize } from '../../services/cloudinaryService';
import { config } from '../../config/';

// actions
import { itemRemove } from '../../actions/orders';
import { getEvents } from '../../actions/cardEvents';

// components
import OverlayLoader from '../../parts/OverlayLoader';

function valueAddImageHack(range, catNo) {
  // This information just isn't availale until after full payment, so it has to be harded here 
  switch (range.toUpperCase()) {
    case 'CARE KIT':
    case 'SOFOLOGY':
    case 'SOFOLOGY FABRIC':
    case 'SOFOLOGY LEATHER':
    case 'SOFOLOGY CAREKIT':
      return 'http://images.sofology.co.uk/image/upload/c_pad,q_70,h_100,fl_lossy/v1473410307/ecom/CareKit.jpg';
    case 'SMALL VAN':
      return 'http://images.sofology.co.uk/image/upload/v1443176422/elem/product-page/images/swatches-truck.png';
    case 'SOFARESCUE':
      return 'https://images.sofology.co.uk/image/upload/v1585655304/sofarescue-mysof-icon_tfy3xz.png';
    case 'SOFASHIELD':
      return catNo === 'sofaShieldReclinerVa' || catNo === '359-10008' ?
        '//images.sofology.co.uk/b_rgb:fff,c_pad,q_100,h_150,fl_lossy,f_auto//v1533569881/sofashield-technical-2_1_b144hs.jpg' :
        'http://images.sofology.co.uk/image/upload/c_pad,q_70,h_100,fl_lossy/v1473410308/ecom/sofashield.jpg';
    case 'SOFASHIELD PLUS':
      return 'https://images.sofology.co.uk/image/upload/c_pad,q_70,h_100,fl_lossy/v1733493008/Sofashield/sofashield_nsuhdh_1.png';
    case 'SOFA': // Range name for SofaRescue is 'SOFA'
      return 'https://images.sofology.co.uk/c_pad,q_70,h_125,fl_lossy,f_auto//v1585655304/sofarescue-mysof-icon_tfy3xz.png';
    default:
      return false;
  }
}

class _BasketItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadState: 'none'
    };
    this.handleItemRemove = this.handleItemRemove.bind(this);
  }

  handleItemRemove(item) {

    const { itemRemove, getEvents, orderIdx } = this.props;

    // spinner not implimented, but it could be
    this.setState({
      loadState: 'loading'
    });
    // issue here if more than one item of the same cat no is added,
    // however back end will just remove the first one it finds so the 
    // front end will look correct
    itemRemove(item.catNo, orderIdx)
      .then(() => {
        setTimeout(() => this.setState({ loadState: 'success' }), 5000)
      })
      .catch(() => {
        this.setState({ loadState: 'failure' });
        setTimeout(() => this.setState({ loadState: 'none' }), 3000);
      })
      .finally(() => {
        getEvents();
      });
  }

  render() {

    const { item } = this.props;

    // split detail line to formatable chunks
    let str = item.detail || '';
    let range = (item.product || '').toUpperCase().trim();

    if (range.includes('HOME DELIVERY') || item.catNo === '486-79618' || item.catNo === '486-79622') return null;
    if (!range || range === '') {
      range = str.split(' ')[0];
      // Care kit no longer the fist word, so lets add to these hacks a bit
      if (str.toLowerCase().includes('care kit')) {
        range = 'CARE KIT';
      }

      if (str.toLowerCase().includes('sofashield plus')) {
        range = 'SOFASHIELD PLUS';
      }
    }
    range = `${(range[0] || '').toUpperCase()}${(range.slice(1) || '').toLowerCase()}`;
    str = str.replace(new RegExp(range, 'g'), '');
    str = str.split(' in ');
    const itemDescription = str[0] ? str[0].trim() : '';
    const swatch = str[1] ? `in ${str[1]}`.trim() : '';
    // images for value adds not coming through in rabbit order message
    const itemImage = resize((valueAddImageHack(range, item.catNo) || item.imageUrl), 125);
    const sofologistCookie = Cookie.getJSON('mySofologySofologist');
    const rangeLink = range && range.toUpperCase() !== 'SOFOLOGY' && !range.toUpperCase().includes('SOFASHIELD') && sofologistCookie == null ?
      `${config.URLS.SOFOLOGY_HOME}/sofas/${range.toLowerCase()}?code=${item.catNo}` : '';

    return (
      <li className="u-position-relative">
        <OverlayLoader active={this.state.loadState === 'loading'} background={'rgb(255, 255, 255, 0.7)'} />
        <div
          className="basket__item u-padding-top-small u-padding-bottom-small u-padding-right-small"
        >
          <div className="image-wrap">
            {rangeLink !== '' ? (
              <a href={rangeLink}>
                <img src={itemImage} alt={`${range} product details page`} />
              </a>
            ) : <img src={itemImage} alt={`${range} product details page`} />
            }
            {item.qty > 1 ? (
              <span className="quantity">
                x{item.qty}
              </span>
            ) : null
            }
          </div>

          <div className="description u-padding-left-small">
            <div className="range">{range}</div>
            <div className="web-description">{itemDescription}</div>
            <div className="swatch">{swatch}</div>
          </div>
        </div>

        <div className="basket__value u-padding-small u-padding-top-medium">
          <div >
            £{decimalOrBust(item.value)}
          </div>

          {(item.itemType === "basket")
            ?
            <div
              className="basket__itemRemoveButton"
              onClick={() => this.handleItemRemove(item)}
              disabled={this.state.loadState === 'loading'}
            >
              Remove
            </div>
            :
            <div></div>
          }
        </div>


      </li>
    );
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({ itemRemove, getEvents }, dispatch);


const BasketItem = connect(null, mapDispatchToProps)(_BasketItem);

export default BasketItem;




// WEBPACK FOOTER //
// ./src/parts/Basket/BasketItem.js